module.exports = __webpack_public_path__ + "static/texture-purple-49f83cc5d2a502f330ff48a39a41eff9.png";